import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    class: "g-search-box__custom-list",
    role: "listbox"
};
const _hoisted_2 = ["data-highlighted", "aria-selected", "onClick"];
const _hoisted_3 = {
    key: 0,
    class: "g-search-box__empty"
};
const _hoisted_4 = {
    key: 1,
    class: "g-search-box__loading-more"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, idx) => {
            return (_openBlock(), _createElementBlock("div", {
                key: String(item[_ctx.idField]) + idx,
                class: _normalizeClass(["g-search-box__custom-item", {
                        'g-search-box__custom-item--active': _ctx.isSelected(item),
                        'g-search-box__custom-item--highlighted': idx === _ctx.highlightedIndex,
                    }]),
                "data-highlighted": idx === _ctx.highlightedIndex ? true : undefined,
                role: "option",
                "aria-selected": _ctx.isSelected(item),
                onClick: ($event) => (_ctx.$emit('select', item))
            }, [
                _renderSlot(_ctx.$slots, "item", {
                    item: item,
                    index: idx,
                    isSelected: _ctx.isSelected(item),
                    isHighlighted: idx === _ctx.highlightedIndex
                })
            ], 10, _hoisted_2));
        }), 128)),
        (!_ctx.isLoading && _ctx.items.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Keine Ergebnisse"))
            : _createCommentVNode("", true),
        (_ctx.isLoadingMore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("span", {
                        class: "spinner-border spinner-border-sm",
                        role: "status",
                        "aria-label": "Lädt..."
                    }, null, -1)
                ]))]))
            : _createCommentVNode("", true)
    ]));
}
